module.exports = __webpack_public_path__ + "ba885da68383a2af2f9fcf8bf4cc3167.pdf";